
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RejectionGrid extends Serenity.EntityGrid<RejectionRow, any> {
        protected getColumnsKey() { return 'Inventory.Rejection'; }
        protected getDialogType() { return RejectionDialog; }
        protected getIdProperty() { return RejectionRow.idProperty; }
        protected getInsertPermission() { return RejectionRow.insertPermission; }
        protected getLocalTextPrefix() { return RejectionRow.localTextPrefix; } 
        protected getService() { return RejectionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(18);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[18].AutoPosting;
            this.editItem(<RejectionRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 18,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
    }
}